import { useState } from 'react';
import { useAsync } from 'react-async';
import cn from 'classnames';
import { useParams } from 'react-router-dom';

import { getApprovedTicketListForUser } from '@core';
import Card from 'components/Card';
import styles from './TicketRequestList.module.sass';
import Table from './Table';

export const TicketRequestList = () => {
  const params = useParams();

  const { data: usersList, isLoading: isUserListLoading } = useAsync({
    promiseFn: getApprovedTicketListForUser,
    id: params.id,
  });

  return (
    <>
      <Card className={styles.card} classTitle={cn('title-purple', styles.title)}>
        <div className={cn(styles.row, { [styles.flex]: true })}>
          <Table tickets={usersList?.data} isRequestLoading={isUserListLoading} className={styles.table} />
        </div>
      </Card>
    </>
  );
};
